import { render, staticRenderFns } from "./FinalMessage.vue?vue&type=template&id=0bde7fca&scoped=true"
import script from "./FinalMessage.vue?vue&type=script&lang=js"
export * from "./FinalMessage.vue?vue&type=script&lang=js"
import style0 from "./FinalMessage.vue?vue&type=style&index=0&id=0bde7fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bde7fca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
